import { createContext } from "react";
import { InternalCuratedSearchFilters } from "../__generated__/graphql";
import { gql } from "@apollo/client";

export const AutopilotCuratedInternalSearchContext_InternalSearchFilters = gql`
  fragment AutopilotCuratedInternalSearchContext_InternalSearchFilters on InternalCuratedSearchFilters {
    jobTitles
    industries {
      label
    }
    geographies {
      id
      label
    }
    companyHQLocations {
      id
      label
    }
    companyHeadCountRange {
      upperBound
      lowerBound
    }
    companyNames {
      label
    }
    companyKeywords
    profileSummaryKeywords
  }
`;

const AutopilotCuratedInternalSearchContext = createContext({
  onSaveFilters: ({
    currentFilters,
    additionalFiltering,
  }: {
    currentFilters: InternalCuratedSearchFilters;
    additionalFiltering: string[];
  }) => {
    return;
  },
} as {
  onSaveFilters: (value: {
    currentFilters: InternalCuratedSearchFilters;
    additionalFiltering: string[];
  }) => Promise<void>;
});

export default AutopilotCuratedInternalSearchContext;
